import { Controller } from '@hotwired/stimulus';
import { getComponent } from '@symfony/ux-live-component';

export default class extends Controller {
    async initialize () {
        this.component = await getComponent(this.element);

        const $checkoutAddressForm = document.querySelector('[data-checkout-address="root"]');

        const $countrySelect = $checkoutAddressForm.querySelector('[data-country-code]');

        const $countrySelectBilling = $checkoutAddressForm.querySelector('[data-country-billing-code]');

        const $billingAddressCheckbox = $checkoutAddressForm.querySelector('[data-different-billing-address="checkbox"]');
        const $billingAddressLabel = $checkoutAddressForm.querySelector('[data-different-billing-address="label"]');
        const $billingAddressContent = $checkoutAddressForm.querySelector('[data-different-billing-address="content"]');
        const $billingAddressInputField = $checkoutAddressForm.querySelectorAll('[data-different-billing-address="input"]');

        let countryData;
        if ($countrySelect) {
            countryData = $countrySelect.getAttribute('data-country-code').toLowerCase();
        }

        let countryBillingData;
        if ($countrySelectBilling) {
            countryBillingData = $countrySelectBilling.getAttribute('data-country-billing-code').toLowerCase();
        }

        const handleAriaDifferentBillingAddress = () => {
            if ($billingAddressCheckbox.checked) {
                $billingAddressLabel.setAttribute('aria-expanded', 'true');
                $billingAddressContent.setAttribute('aria-hidden', 'false');
                $billingAddressContent.classList.add('is--visible');
                $billingAddressInputField.forEach($areaInputs => {
                    $areaInputs.removeAttribute('tabindex');
                });
            } else {
                $billingAddressLabel.setAttribute('aria-expanded', 'false');
                $billingAddressContent.setAttribute('aria-hidden', 'true');
                $billingAddressContent.classList.remove('is--visible');
                $billingAddressInputField.forEach($areaInputs => {
                    $areaInputs.setAttribute('tabindex', -1);
                });
            }
        };

        if ($billingAddressCheckbox != null) {
            handleAriaDifferentBillingAddress();
        }

        const checkFormFieldsHasError = () => {
            const $firstFieldWithError = $checkoutAddressForm.querySelector('.has--error');

            if ($firstFieldWithError) {
                const $inputField = $firstFieldWithError.querySelector('input');

                if ($inputField) {
                    $inputField.focus();
                    $inputField.scrollTo();
                }
            }
        };

        this.component.on('render:finished', () => {
            // check if any input fields has errors inside our component
            checkFormFieldsHasError();

            if ($checkoutAddressForm && countryData != null) {
                const currentSelectedCountry = $countrySelect.getAttribute('data-country-code').toLowerCase();
                if (currentSelectedCountry !== countryData) {
                    countryData = currentSelectedCountry;
                }

                if ($countrySelectBilling) {
                    const currentSelectedBillingCountry = $countrySelectBilling.getAttribute('data-country-billing-code').toLowerCase();
                    if (currentSelectedBillingCountry !== countryBillingData) {
                        countryBillingData = currentSelectedBillingCountry;
                    }
                }

                if ($billingAddressCheckbox != null) {
                    handleAriaDifferentBillingAddress();
                }
            }
        });
    }
}
